<template>
    <div id="main_header_container">
        <span
         v-if="title === ''"
         style="margin-left: 20px;font-size: 18px;line-height:40px;color:#acacaf;"
        >
          {{content}}
        </span>
        <div  style="display:inline-block;line-height:40px;">
          <el-page-header
              id="page_header"
              v-if="title !== ''"
              @back="goBack"
              :title="title"
              :content="content"
          >
          </el-page-header>
        </div>
        <a v-on:click="goHome" href="#" style="text-decoration: none;">
          <span
            v-if="content !== '首页'"
            :style="homeBtnStyle"
          >
            <i class="el-icon-arrow-right"></i>
            首页
          </span>
        </a>
    </div>
</template>
<script>
export default {
  name: 'MainHeaderNav',

  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    goBack: {
      type: Function,
      default: () => {}
    }
  },

  methods: {
    goHome () {
      this.$router.push('/index')
    }
  },

  computed: {
    homeBtnStyle () {
      var style = {
        'font-size': '18px',
        'line-height': '40px',
        color: '#acacaf',
        position: 'relative'
      }
      if (this.$props.title !== '') {
        style['margin-left'] = '10px'
        style.top = '-1px'
      }
      return style
    }
  }
}
</script>
<style>
#main_header_container {
  position: absolute;
  top: 66px;
  width: calc(100% - 250px);
  height:40px;
  background-color: #f1f9ff;
  text-align: left;
  z-index: 5;
}

#page_header {
    margin-left: 20px;
    color:#acacaf;
    line-height:40px;
}

#page_header div{
    color:#acacaf;
}
</style>
